export function generateImagePlaceholder(width, height) {
  return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23001319' fill-rule='nonzero' d='M0 0h300v200H0z'/%3E%3C/svg%3E`
}
